/**
 * Port of Angular's grid-parser-mapping.js (ELIGIBILITY_GRID)
 * and eligibility-grid-parser.js (traversal functions).
 *
 * The grid maps card-type hierarchy paths (e.g. ["Basic","Consumer","Charge","Gold"])
 * to the newsletter codes a card of that type is eligible for.
 */

export const ELIGIBILITY_GRID = {
  Basic: {
    Corporate: {
      ProductNewsletters: [],
      OptInNewsLetters: ['SKYGUI']
    },
    ProductNewsletters: ['MKMEMB', 'MKOFFR', 'MKGIFT', 'MKCORP', 'MKRESR'],
    Business: {
      Lending: {
        Others: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        Delta: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        Lowes: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        LineOfCredit: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        MR: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        BusinessCapitalLine: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        CashRebate: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        BMA: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        Blue: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: [],
          Cash: {
            ProductNewsletters: ['MKNEWS'],
            OptInNewsLetters: []
          }
        },
        ProductNewsletters: [],
        OptInNewsLetters: [],
        Platinum: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: ['WORLDW']
        },
        Gold: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        Costco: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        }
      },
      OptInNewsLetters: [],
      Charge: {
        Executive: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        ProductNewsletters: [],
        Others: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        Green: {
          ProductNewsletters: ['MKNEWS'],
          Reward: {
            ProductNewsletters: ['MKNEWS'],
            OptInNewsLetters: []
          },
          OptInNewsLetters: []
        },
        Lowes: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        OptInNewsLetters: [],
        Platinum: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: ['WORLDW']
        },
        Gold: {
          ProductNewsletters: ['GCEVNT', 'MKNEWS'],
          OptInNewsLetters: []
        },
        Costco: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        Centurion: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        }
      }
    },
    Consumer: {
      ProductNewsletters: [],
      Lending: {
        Delta: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        Chicago: {
          ProductNewsletters: ['CHIALR'],
          OptInNewsLetters: []
        },
        Clear: {
          ProductNewsletters: ['CLEARC'],
          OptInNewsLetters: []
        },
        CashRebate: {
          ProductNewsletters: ['CSHRBT'],
          OptInNewsLetters: []
        },
        BlueCashEveryday: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        MercedesBenzLending: {
          ProductNewsletters: [],
          OptInNewsLetters: [],
          G1A: {
            ProductNewsletters: ['MKNEWS'],
            OptInNewsLetters: []
          }
        },
        Blue: {
          ProductNewsletters: ['MKNEWS'],
          Classic: {
            ProductNewsletters: ['MKNEWS'],
            OptInNewsLetters: []
          },
          OptInNewsLetters: [],
          Cash: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          },
          Clear: {
            ProductNewsletters: ['CLEARC'],
            OptInNewsLetters: []
          },
          Sky: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          }
        },
        ProductNewsletters: [],
        BlueSkyPreferred: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        OptInNewsLetters: [],
        Platinum: {
          ProductNewsletters: [],
          OptInNewsLetters: [],
          CashRebate: {
            ProductNewsletters: ['PLACSH'],
            OptInNewsLetters: []
          }
        },
        Hilton: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: [],
          '7X4': {
            ProductNewsletters: ['MKNEWS'],
            OptInNewsLetters: []
          },
          738: {
            ProductNewsletters: ['MKNEWS'],
            OptInNewsLetters: []
          }
        },
        Golf: {
          OptInNewsLetters: [],
          ProductNewsletters: []
        },
        NRA: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        BlueCashRebate: {
          ProductNewsletters: ['AEDCSH'],
          OptInNewsLetters: []
        },
        KnicksRanger: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        NYC: {
          ProductNewsletters: ['NYCALR'],
          OptInNewsLetters: []
        },
        HO1: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        HO2: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        HO3: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        MorganStanleyLending: {
          ProductNewsletters: [],
          G06: {
            ProductNewsletters: ['MKNEWS'],
            OptInNewsLetters: []
          },
          OptInNewsLetters: []
        },
        HO4: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        JetBlue: {
          ProductNewsletters: ['JETBLU'],
          OptInNewsLetters: []
        },
        LA: {
          ProductNewsletters: ['LACALR'],
          OptInNewsLetters: []
        },
        Student: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        NationalMS: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        FSA: {
          OptInNewsLetters: [],
          ProductNewsletters: []
        },
        BlueCashPreferred: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        Costco: {
          ProductNewsletters: ['TRUERN'],
          OptInNewsLetters: [],
          CashRebate: {
            ProductNewsletters: ['COSCSH'],
            OptInNewsLetters: []
          }
        },
        StarWoods: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        }
      },
      OptInNewsLetters: ['AMXCUR'],
      Charge: {
        Student: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: []
        },
        Fidelity: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Recovery: {
          OptInNewsLetters: [],
          ProductNewsletters: []
        },
        Znyc: {
          ProductNewsletters: ['ZYNCPN', 'MKNEWS'],
          OptInNewsLetters: ['ZYNCMU', 'ZYNCSO']
        },
        FSA: {
          OptInNewsLetters: [],
          ProductNewsletters: []
        },
        Platinum: {
          ProductNewsletters: ['MKNEWS', 'GCEVNT', 'PLATSE'],
          OptInNewsLetters: ['WORLDW']
        },
        Gold: {
          Standard: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          },
          ProductNewsletters: ['MKNEWS', 'GCEVNT'],
          Reward: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          },
          OptInNewsLetters: []
        },
        One: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Centurion: {
          ProductNewsletters: ['MKNEWS', 'GCEVNT', 'CENTSP'],
          OptInNewsLetters: []
        },
        Personal: {
          Standard: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          },
          ProductNewsletters: ['MKNEWS'],
          Reward: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          },
          OptInNewsLetters: []
        }
      }
    },
    OptInNewsLetters: ['TKTACC']
  },
  Supp: {
    ProductNewsletters: [],
    OptInNewsLetters: ['TKTACC'],
    Corporate: {
      ProductNewsletters: [],
      OptInNewsLetters: ['SKYGUI']
    },
    Business: {
      Lending: {
        BMA: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Blue: {
          ProductNewsletters: [],
          OptInNewsLetters: [],
          Cash: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          }
        },
        ProductNewsletters: [],
        Others: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Delta: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        OptInNewsLetters: [],
        LineOfCredit: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Platinum: {
          ProductNewsletters: [],
          OptInNewsLetters: ['WORLDW']
        },
        Gold: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Costco: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        MR: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        BusinessCapitalLine: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        CashRebate: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        }
      },
      OptInNewsLetters: [],
      Charge: {
        Executive: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        ProductNewsletters: [],
        Green: {
          ProductNewsletters: [],
          Reward: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          },
          OptInNewsLetters: []
        },
        OptInNewsLetters: [],
        Platinum: {
          ProductNewsletters: [],
          OptInNewsLetters: ['WORLDW']
        },
        Gold: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Costco: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Centurion: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        }
      }
    },
    Consumer: {
      ProductNewsletters: [],
      Lending: {
        KnicksRanger: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Delta: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        NYC: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Chicago: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        HO1: {
          ProductNewsletters: ['EVRDAY'],
          OptInNewsLetters: []
        },
        HO2: {
          ProductNewsletters: ['EVRDAY'],
          OptInNewsLetters: []
        },
        HO3: {
          ProductNewsletters: ['EVRDAY'],
          OptInNewsLetters: []
        },
        HO4: {
          ProductNewsletters: ['EVRDAY'],
          OptInNewsLetters: []
        },
        CashRebate: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        LA: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Student: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Blue: {
          ProductNewsletters: [],
          Classic: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          },
          OptInNewsLetters: [],
          Cash: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          },
          Sky: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          }
        },
        ProductNewsletters: [],
        NationalMS: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        FSA: {
          OptInNewsLetters: [],
          ProductNewsletters: []
        },
        OptInNewsLetters: [],
        Platinum: {
          ProductNewsletters: [],
          OptInNewsLetters: [],
          CashRebate: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          }
        },
        Hilton: {
          ProductNewsletters: ['MKNEWS'],
          OptInNewsLetters: [],
          '7X4': {
            ProductNewsletters: ['MKNEWS'],
            OptInNewsLetters: []
          },
          738: {
            ProductNewsletters: ['MKNEWS'],
            OptInNewsLetters: []
          }
        },
        Golf: {
          OptInNewsLetters: [],
          ProductNewsletters: []
        },
        StarWoods: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Costco: {
          ProductNewsletters: [],
          OptInNewsLetters: [],
          CashRebate: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          }
        },
        NRA: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        }
      },
      OptInNewsLetters: ['AMXCUR'],
      Charge: {
        Student: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Fidelity: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Recovery: {
          OptInNewsLetters: [],
          ProductNewsletters: []
        },
        FSA: {
          OptInNewsLetters: [],
          ProductNewsletters: []
        },
        Platinum: {
          ProductNewsletters: [],
          OptInNewsLetters: ['WORLDW']
        },
        Gold: {
          Standard: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          },
          ProductNewsletters: [],
          Reward: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          },
          OptInNewsLetters: []
        },
        One: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Centurion: {
          ProductNewsletters: [],
          OptInNewsLetters: []
        },
        Personal: {
          Standard: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          },
          ProductNewsletters: [],
          Reward: {
            ProductNewsletters: [],
            OptInNewsLetters: []
          },
          OptInNewsLetters: []
        }
      }
    }
  }
};

/**
 * Port of Angular eligibility-grid-parser.js → getEligibleNewsLetters.
 *
 * Walks down the grid tree following the card-type hierarchy path
 * (e.g. ["Basic","Consumer","Charge","Gold"]) and accumulates
 * ProductNewsletters and OptInNewsLetters at every node along the path.
 *
 * @param {string[]} prodHierArr  Card type path from cardGroupIdentifier
 * @param {object}   eligibilityBase  { Basic: ELIGIBILITY_GRID.Basic } or { Supp: ... }
 * @returns {{ OptInNewsLetters: string[], ProductNewsLetters: string[] }}
 */
export const getEligibleNewsLetters = (prodHierArr, eligibilityBase) => {
  let hierArr = prodHierArr;
  if (!hierArr || hierArr.length === 0) {
    hierArr = ['Basic'];
  }
  const prodNL = [];
  const optInNL = [];
  for (let i = 0; i < hierArr.length; i += 1) {
    let count = 0;
    let shallILoop = false;
    let tempInside = {};
    let temp = eligibilityBase;
    if (temp && temp[hierArr[i]]) {
      shallILoop = true;
    }
    while (shallILoop) {
      tempInside = temp[hierArr[count]];
      if (tempInside) {
        if (tempInside.OptInNewsLetters) {
          optInNL.push(...tempInside.OptInNewsLetters);
        }
        if (tempInside.ProductNewsletters) {
          prodNL.push(...tempInside.ProductNewsletters);
        }
      }
      count += 1;
      if (count > hierArr.length) {
        shallILoop = false;
      } else {
        const tempNextToken = hierArr[count];
        const tempCurrentNode = temp;
        temp = tempInside;
        shallILoop = false;
        if (temp && temp[tempNextToken]) {
          shallILoop = true;
        } else {
          temp = tempCurrentNode;
          if (temp && temp[tempNextToken]) {
            shallILoop = true;
          }
        }
      }
    }
  }
  return {
    OptInNewsLetters: optInNL,
    ProductNewsLetters: prodNL
  };
};

/**
 * Port of Angular eligibility-grid-parser.js → getCompleteInfoOfAllEligibleNewsLetters.
 *
 * Cross-references per-card eligible codes against master data,
 * producing the full master-data object for each eligible code.
 *
 * Returns:
 *   {
 *     [cardNumber]: masterDataEntry[],   // product newsletters per card
 *     OptInNewsLetters: masterDataEntry[], // global opt-in newsletters
 *     totData: string[],                  // flat list of all eligible comm codes
 *   }
 */
export const getCompleteEligibleNewsLetters = (eligibleLettersByCard, masterData, cardNumbers) => {
  if (!eligibleLettersByCard || Object.keys(eligibleLettersByCard).length === 0) {
    return null;
  }
  const optInNewsLetters = [];
  const result = {};
  const totArr = [];
  cardNumbers.forEach(cardNumber => {
    const nlForCard = eligibleLettersByCard[cardNumber];
    if (!nlForCard) return;

    // OptIn newsletters (cross-ref master data, deduplicate)
    (nlForCard.OptInNewsLetters || []).forEach(name => {
      if (masterData[name] && !totArr.includes(name)) {
        optInNewsLetters.push(masterData[name]);
        totArr.push(name);
      }
    });

    // Product newsletters per card (cross-ref master data)
    const tempProdData = [];
    (nlForCard.ProductNewsLetters || []).forEach(name => {
      if (masterData[name]) {
        tempProdData.push(masterData[name]);
        totArr.push(name);
      }
    });
    result[cardNumber] = tempProdData;
  });
  result.OptInNewsLetters = optInNewsLetters;
  result.totData = totArr;
  return result;
};